import React from "react";
import { Field, reduxForm } from "redux-form";
import { Input, Checkbox, Button } from "expano-components";
import { Main } from "layouts";
import { createSupplier } from "actions/suppliers";
import { connect } from "react-redux";

import { ReactComponent as SupplierIcon } from "icons/supplier.svg";
import { ReactComponent as InfoIcon } from "icons/info.svg";

const InputField = (props) => <Input {...props} />;
const CheckField = (props) => <Checkbox {...props} />;

const SupplierNew = ({
  pristine,
  invalid,
  submitting,
  history,
  handleSubmit,
}) => {
  const onSubmit = (values) =>
    createSupplier(values).then((id) => history.push(`/suppliers/${id}`));

  return (
    <Main
      page={{
        name: "Nowy dostawca",
        icon: <SupplierIcon />,
        breadcrumbs: [
          { name: "Dostawcy", path: "/suppliers" },
          { name: "Nowy dostawca" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="dashboard column-half m-t-10">
          <header className="dashboard__header">
            <div className="icon__container">
              <InfoIcon />
            </div>
            <h2 className="dashboard__title heading">Podstawowe dane</h2>
          </header>
          <form
            noValidate
            onSubmit={handleSubmit(onSubmit)}
            className="dashboard__form p-t-20"
          >
            <div className="dashboard-wrapper-flex m-b-20">
              <div className="column-half">
                <Field name="name" label="Nazwa" component={InputField} />
              </div>
              <div className="column-half">
                <Field
                  name="full_name"
                  label="Pełna nazwa"
                  component={InputField}
                />
              </div>
            </div>
            <div className="dashboard-wrapper-flex m-b-20">
              <div className="column-half">
                <Field name="email" label="E-mail" component={InputField} />
              </div>
              <div className="column-half">
                <Field
                  name="phone"
                  type="phone"
                  label="Telefon"
                  component={InputField}
                />
              </div>
            </div>
            <div className="dashboard-wrapper-flex m-b-20">
              <div className="column-half">
                <Field
                  name="min_logistic_price"
                  type="number"
                  label="Minimum logistyczne"
                  component={InputField}
                />
              </div>
              <div className="column-half">
                <Field name="address" label="Adres" component={InputField} />
              </div>
            </div>
            <div className="dashboard-wrapper-flex">
              <div className="column-half">
                <Field
                  name="erp_code"
                  label="Akronim dostawcy"
                  component={InputField}
                />
              </div>
            </div>
            <div className="dashboard-wrapper-flex m-b-20">
              <div className="column-half">
                <Field
                  name="generate_task_for_missing_product"
                  label="Generuj zadanie inwentaryzacji dla brakujących produktów"
                  component={CheckField}
                />
              </div>
              <div className="column-half">
                <Field
                  name="deliveries_require_inspection"
                  label="Dostawy od tego dostawcy wymagają kontroli"
                  component={CheckField}
                />
              </div>
            </div>
            <div className="dashboard__form__footer">
              <Button
                disabled={invalid || pristine || submitting}
                type="save"
                text="Zapisz"
                onClick={handleSubmit(onSubmit)}
              />
            </div>
          </form>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Pole wymagane";
  }

  return errors;
};

export default connect(() => ({
  initialValues: {
    min_logistic_price: 0,
    generate_task_for_missing_product: false,
    deliveries_require_inspection: false,
  },
}))(
  reduxForm({
    form: "add-supplier",
    validate,
  })(SupplierNew),
);
